module.exports = __webpack_public_path__ + "static/media/exchange.97fc022f.svg";